export class Usuario {
  id: number;
  loginAcesso: string;
  email: string;
  senha: string;
  nome: string;
  apelido: string;
  perfil: number;
}
